import React from 'react'

import FieldLabel from '@react/react-spectrum/FieldLabel'
import Textfield from '@react/react-spectrum/Textfield'

import MediaUpload from 'components/MediaUpload'
import { ScreenPicker } from '../../ScreenPicker'
import SharedSections from './SharedSections'

const HeroBanner = ({ screen, project, disabled, onChange }) => {
  const content = screen?.content
  return (
    <>
      <FieldLabel label='Heading'>
        <Textfield
          placeholder='Heading'
          name='heading'
          value={content.heading || ''}
          onChange={onChange('heading')}
          disabled={disabled}
        />
      </FieldLabel>

      <FieldLabel label='Hero Image' labelFor='heroImage'>
        <MediaUpload
          type='image'
          value={content.heroImage || ''}
          maxHeight='100px'
          onUpload={onChange('heroImage')}
          projectId={project?.meta?.id}
          path={`home-${screen?.meta?.name}-heroImage`}
          withTextfield={true}
          disabled={disabled}
        />
      </FieldLabel>

      <FieldLabel label='Hero mbox' labelFor='heroMbox'>
        <Textfield
          placeholder='mbox name'
          name='heroMbox'
          value={content.heroMbox || ''}
          onChange={onChange('heroMbox')}
          disabled={disabled}
        />
      </FieldLabel>

      <FieldLabel label='Button Label' labelFor='buttonLabel'>
        <Textfield
          placeholder='Button Label'
          name='buttonLabel'
          value={content.buttonLabel || ''}
          onChange={onChange('buttonLabel')}
          disabled={disabled}
        />
      </FieldLabel>

      <FieldLabel label='Button Link' labelFor='buttonLink'>
        <ScreenPicker
          screenName={screen?.meta?.name}
          value={content.buttonLink}
          onChange={onChange('buttonLink')}
          disabled={disabled}
        />
      </FieldLabel>
    </>
  )
}

const List = ({ screen, disabled, onChange }) => {
  const content = screen?.content
  return (
    <>
      <FieldLabel label='List Headline' labelFor='listHeadline'>
        <Textfield
          placeholder='List Headline'
          name='listHeadline'
          value={content.listHeadline || ''}
          onChange={onChange('listHeadline')}
          disabled={disabled}
        />
      </FieldLabel>

      <FieldLabel label='List Items' labelFor='list'>
        <ScreenPicker
          screenName={screen?.meta?.name}
          screens={content.list}
          onChange={onChange('list')}
          disabled={disabled}
          multiple
        />
      </FieldLabel>
    </>
  )
}

const BottomBanner = ({ screen, project, disabled, onChange }) => {
  const content = screen?.content
  return (
    <>
      <FieldLabel label='Bottom Image' labelFor='bottomImage'>
        <MediaUpload
          type='image'
          value={content.bottomImage || ''}
          maxHeight='100px'
          onUpload={onChange('bottomImage')}
          projectId={project?.meta?.id}
          path={`home-${screen?.meta?.name}-bottomImage`}
          withTextfield={true}
          disabled={disabled}
        />
      </FieldLabel>

      <FieldLabel label='Bottom Title' labelFor='bottomTitle'>
        <Textfield
          placeholder='Bottom Title'
          name='bottomTitle'
          value={content.bottomTitle || ''}
          onChange={onChange('bottomTitle')}
          disabled={disabled}
        />
      </FieldLabel>

      <FieldLabel label='Bottom Subtitle' labelFor='bottomSubtitle'>
        <Textfield
          placeholder='Bottom Subtitle'
          name='bottomSubtitle'
          value={content.bottomSubtitle || ''}
          onChange={onChange('bottomSubtitle')}
          disabled={disabled}
        />
      </FieldLabel>
    </>
  )
}

export default [
  { label: 'Hero Banner', content: HeroBanner },
  { label: 'List', content: List },
  { label: 'Bottom Banner', content: BottomBanner },
  ...SharedSections,
]
